"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_modal_1 = (0, tslib_1.__importDefault)(require("react-modal"));
const S = (0, tslib_1.__importStar)(require("./styles"));
const Button_1 = (0, tslib_1.__importDefault)(require("../../atoms/Button"));
const ModalStandard = ({ isModalOpen, toggleModal, size, }) => {
    (0, react_1.useEffect)(() => {
        const { content } = S.customStyles;
        if (size === 'small' && content) {
            content.width = '20%';
        }
        else if (size === 'medium' && content) {
            content.width = '50%';
        }
        else if (size === 'large' && content) {
            content.width = '90%';
        }
    }, [size]);
    return ((0, jsx_runtime_1.jsxs)(react_modal_1.default, Object.assign({ isOpen: isModalOpen, style: S.customStyles }, { children: [(0, jsx_runtime_1.jsx)(S.ButtonCloseModal, { onClick: toggleModal, title: "Close" }, void 0), (0, jsx_runtime_1.jsx)(S.Title, { children: "Hello" }, void 0), (0, jsx_runtime_1.jsx)("div", { children: "I am a modal" }, void 0), (0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsx)(Button_1.default, { size: "medium", label: "Submit", colorOption: 'blue' }, void 0) }, void 0)] }), void 0));
};
exports.default = ModalStandard;
